<template>
  <section-layout
    :disabled="!cambiado || loading"
    :loading="loading || saving"
    :showButton="false"
  >
    <template v-slot:title>
      {{ localization.tabsTitles.tiposSolicitudes }}
    </template>
    <template v-slot:content>
      <v-row justify="start" align="center" dense>
        


          <v-col cols="12">
            <v-tabs v-model="seccionActual" id="seccionActual" grow color="primary"
              background-color="transparent" class="transparentTabs">
              <v-tab v-for="(item, index) in items" :key="index + '-tab'">
                <v-row justify="center" align="center">
                  {{item.name}}
                </v-row>
              </v-tab>
              <v-tab-item v-for="(item, index) in items" :key="index + '-tab-item'">
                <v-container fluid>
                <component :is="item.tipo"                 
                  :configuracion="configuracion"
                  :item="item"
                  :saving="saving"
                  :valid="valid"
                  @cambiado="updateCambiado($event, index)"
                  @toggleValidProp="toggleValidProp($event)"
                />
              </v-container>
            </v-tab-item>
          </v-tabs>
        </v-col>

      </v-row>
    </template>
  </section-layout>
</template>

<script>

import tiposSolicitudesGeneral from './tiposSolicitudesGeneral'
import tiposSolicitudesCliente from './tiposSolicitudesCliente'
import tiposSolicitudesClienteWeb from './tiposSolicitudesClienteWeb'

export default {
  components: {
    tiposSolicitudesGeneral,
    tiposSolicitudesCliente,
    tiposSolicitudesClienteWeb
  },
  props: {
    saving: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      default: false
    },
    cambiado: {
      type: Boolean,
      default: false
    },
    configuracion: {
      type: Object,
      required: true
    }
  },
  async created () {
    const loader = this.$loading.show({
      container: this.fullPage ? null : this.$refs.formContainer,
      canCancel: false
    })
    try {
      this.loading = true
    } catch (error) {
      this.addAlert({ texto: this.$t('errorCargaDeDatos'), color: 'error' })
    }
    loader.hide()
    this.loading = false
  },
  data () {
    return {
      seccionActual: 0,
      loading: false,
      breadcrumbs: [
        {
          text: this.$t('navDrawer.home').toUpperCase(),
          disabled: false,
          to: {name: 'home'},
          exact: true
        }
      ]
    }
  },
  computed: {
    localization () {
      return this.$t('sectionConfiguracion')
    },
    translates() {
      if (this.$store.state.configuracion.tiposSolicitudes) {
        return this.$store.state.configuracion.tiposSolicitudes;
      }
      return [];
    },
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    items() {

      let usuario = JSON.parse(localStorage.usuario)
      let entornos = usuario.entornos
      let rolCliente = false
      
      entornos.forEach(entorno => {
        if (entorno.idubapi == this.$store.state.login.credentials.idubapi) {
          rolCliente = entorno.rolCliente
        }
      });

      let itemRolCliente = []
      if (rolCliente) {
        itemRolCliente = [
          {
            name: this.$t('sectionConfiguracion.tabsTitles.tiposSolicitudesClienteWeb'),
            tipo: 'tiposSolicitudesClienteWeb'
          }
        ]
      }
      return [
        {
          name: this.$t('sectionConfiguracion.tabsTitles.estandar'),
          tipo: 'tiposSolicitudesGeneral'
        },
        {
          name: this.$t('sectionConfiguracion.tabsTitles.tiposSolicitudesCliente'),
          tipo: 'tiposSolicitudesCliente'
        },
        ...itemRolCliente
      ]
    }
  },
  methods: {
    updateCambiado (val) {
      // this.cambiado = val
      this.$emit('cambiado', val)
    },
    toggleValidProp (val) {
      this.$emit('toggleValidProp', val)
    }
  },
  watch: {
    cambiado (val) {
      this.$emit('cambiado', val)
    }
  }
}
</script>

<style scoped>
.iconSize {
  width: 16px !important;
}
</style>
